var _script, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaKommersant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    async: "false",
    type: "text/javascript",
    src: "moz-extension://33d4f970-0f6d-4e56-ae9a-a8614e04c84f/in-page.js"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M257 6a250 250 0 1 0 .2 500.2A250 250 0 0 0 257 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004465",
    d: "M257 6a250 250 0 1 0 .2 500.2A250 250 0 0 0 257 6zM46.2 256a211 211 0 0 1 301-190.5 6.7 6.7 0 0 0-5.4.6c-5 3-14 14-21.7 20-20.7 16.5-68.8 50.3-75.1-9-4.7-1-27.2 5-30.6 8-2 1.6-13.8 24.2-15.7 27.4-14 24.4-64.9 97-59.3 117.8.8 3 3 2 3 2l49.2-19.6c12.4-5 22-94.8 34.4-110.9 4-5.2 4-2.1 5 2.1 4.4 19.2 18.2 53.9 43.4 51a91 91 0 0 0 34.2-14c2-1.6 3.5 0 3.2 1.4-.3 1.1-1.3 2.7-1.3 2.7-31.3 45.3-95.9 62-137 119.7a201.2 201.2 0 0 0-38 97.4c-3 34.7 7.7 71 37.4 87.2A211.1 211.1 0 0 1 46.2 256zM257 466.8a210 210 0 0 1-69-11.6c2.5.7 5.2 1.2 8 1.6 97.2 14.5 209.6-144.2 167.9-230.3-11.7-24.2-41.4-24.5-62.6-13.7-46.4 23.5-87 100.1-88.2 150.8-.4 11.9.1 24.2 2.7 35.7 8.3 33.4 37 22.3 38.3 4.2-29.2-11-7.4-163 39.3-171.7 9.2-1.8 16.2 10.4 19.6 17.2 25.4 52.5-29.2 230-103.9 188.5-12.6-6.8-18.7-23.5-21.5-36.7-10.3-51.4 8.6-112.3 42.5-151.8 22-25.6 48.9-46.6 69.9-72.9 13-16.3 23.9-32 34.6-49.8 4.3-6.8 11.9-19.4 16.3-32.2 3.8-11 3-18.7 1.1-24.5a7.9 7.9 0 0 0-2.5-3A211 211 0 0 1 467.8 256 211 211 0 0 1 257 466.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaKommersant);
export default __webpack_public_path__ + "static/media/media_kommersant.e449db18bdc863edc3a2cd7a3dde5f9d.svg";
export { ForwardRef as ReactComponent };